<template>
    <div class="text-a-brown-502314" :class="[isGroup ? 'py-3 first:pt-0 last:pb-0' : 'py-4']">
        <div class="flex items-center gap-3 font-main text-a-brown-502314">
            <div class="flex-auto text-14 lg:text-base">
                <span :class="{ 'font-bold': textBold }">{{ label }}</span>
                <template v-if="extraLabel != ''">
                    <span class="text-12 lg:text-14 text-a-red-d62300  ml-1">
                        {{ extraLabelValue }}
                    </span>
                </template>
            </div>
            <div class="flex-none">
                <button type="button" class="appearance-none outline-none" @click="controller.methods.decrease()">
                    <img v-show="controller.canDecrease.value" :class="large ? 'h-26px w-26px' : 'h-5 w-5'"
                        src="@/assets/icon/ic-delete-red.svg" />
                    <img v-show="!controller.canDecrease.value" :class="large ? 'h-26px w-26px' : 'h-5 w-5'"
                        src="@/assets/icon/ic-minus.off.svg" />
                </button>
            </div>
            <div class="flex-none font-bold text-14 lg:text-16 text-center w-14"
                :class="[controller.minQty == 0 && controller.qty.value == 0 ? 'text-a-brown-9f8273' : 'text-a-brown-502314']">
                {{ controller.qty.value }}
            </div>
            <div class="flex-none">
                <button v-if="controller.maxQty != controller.qty.value" type="button" class="appearance-none outline-none" @click="controller.methods.increase()">
                    <img class="mx-auto" :class="large ? 'h-26px w-26px' : 'h-5 w-5'"
                        src="@/assets/icon/ic-add-red.svg" />
                </button>
                <div v-else class="appearance-none outline-none">
                    <img class="mx-auto" :class="large ? 'h-26px w-26px' : 'h-5 w-5'"
                        src="@/assets/icon/ic-add-brown.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, onMounted, watch, ref, inject } from 'vue'

export default {
    name: 'QuantityControl',
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        controller: {
            type: Object,
        },
        large: {
            type: Boolean
        },
        textBold: {
            type: Boolean,
        },
        isGroup: {
            type: Boolean,
        },
        valueKey: {
            type: String,
            default: "id"
        },
        textKey: {
            type: String,
            default: "name"
        },
        extraLabel: {
            type: String,
            default: ""
        }
    },
    emits: ["update:modelValue", "hasChange"],
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const extraLabelValue = ref("")
        console.log('init qty',props.controller)

        watch(props.controller.qty, (val) => {
            context.emit("update:modelValue", { data: props.controller.item, qty: val })
            context.emit("hasChange")
        })

        const label = computed(() => {
            let data = props.controller.item?.[props.textKey] ?? null
            return data
        })
        // console.log(props.extraLabel)
        if (props.extraLabel == "price") {
            // get pricePerUnit
            let price = props.controller.item?.pricePerUnit ?? 0
            if (price > 0) {
                extraLabelValue.value = `+${price} ${lbl.value.productDetail.priceUnit}`
            } else {
                extraLabelValue.value = ""
            }
        }

        onMounted(() => {
            context.emit("update:modelValue", { data: props.controller.item, qty: props.controller.qty })
        })

        return {
            label,
            extraLabelValue
        }
    }
}
</script>
<style lang="scss" scoped>
    .dummy {
        width: 20px;
    }
</style>
